import Api from 'api'

const config = {
  baseURL: '/api/app/v1/mp',
}
const api = new Api(config)

api.fetchIndustries = ({ benchmark }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/industries`)

api.fetchSubIndustries = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/sub-industries`, {
    ...rest,
  })

api.fetchPlatformLevels1 = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/platform-levels-1`, {
    ...rest,
  })

api.fetchPlatformLevels2 = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/platform-levels-2`, {
    ...rest,
  })

api.fetchStrategyLevels1 = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/strategy-levels-1`, {
    ...rest,
  })

api.fetchTargetValueDistribution = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution`, {
    ...rest,
  })

api.fetchAdCategories = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/ad-categories`, {
    ...rest,
  })

api.fetchAdObjects = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/ad-objects`, {
    ...rest,
  })

api.fetchAdTargets = ({ benchmark, ...rest }) =>
  api.get(`/${benchmark}/target-value-distribution/filters/ad-targets`, {
    ...rest,
  })

export const URL_FILE_XLS = ({ benchmark }) =>
  `${config.baseURL}/${benchmark}/target-value-distribution/file-xls`
export const URL_FILE_PDF = ({ benchmark }) =>
  `${config.baseURL}/${benchmark}/target-value-distribution/file-pdf`

export default api
